import React from 'react';
import { Global } from '@emotion/react';
import { cssReset } from 'ui_system/token_auth/styles_root';
import { Logo } from './logo';
import { Container, H1, BodyText, RedLink, BareHR, P } from './PrivacyStyles';

const PrivacyNotEligible = () => (
  <React.Fragment>
    <Global styles={cssReset({})} />
    <Logo />
    <BareHR />
    <Container>
      <H1>Not a California resident?</H1>
      <BodyText>
        <P>
          The information you provided suggests you are not a resident of
          California. If you are not a California resident, the CCPA rights
          requests are not available to you.
        </P>
        <P>
          If you are a California resident and you believe you have landed on
          this page in error, please{' '}
          <RedLink href="/ccpa">resubmit your request</RedLink>. For more
          information, refer to our complete
          <RedLink href="https://www.anyroad.com/privacy">
            {' '}
            Privacy Policy
          </RedLink>
          .
        </P>
      </BodyText>
    </Container>
  </React.Fragment>
);

export default PrivacyNotEligible;
